module.exports = __webpack_public_path__ + "static/service-icon4-65bf0837996ebea2201c75518f72defa.png";